import React from 'react';
import { isTouchDevice, supportsSvgCssAnimation } from '../../../utils/browser';

export default function CSSFeatures({ children }) {
  function getClasses() {
    const classes = ['CSSFeatures'];
    if (isTouchDevice()) {
      classes.push('CSSFeatures--Touch');
    }
    if (supportsSvgCssAnimation()) {
      classes.push('CSSFeatures--SvgCssAnimation');
    }
    return classes.join(' ');
  }

  return <div className={getClasses()}>{children}</div>;
}



// WEBPACK FOOTER //
// ./src/app/ui/core/common/CSSFeatures.js